<template>
    <div>

        <!-- Modal -->
        <div class="modal fade" id="chatPanelModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensagem</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="!to">
                            <div class="mb-2">
                                <az-input
                                    icon="fa fa-search" 
                                    sizing="sm"
                                    ref="search_chat"
                                    v-model="search">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">{{ online ? online.length : 0 }}</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" v-for="(user, iux) in lista" :key="iux" 
                                    :disabled="user.id_usuario == $store.state.user.id_usuario" @click="to = user">
                                    {{ user.search ? user.search : user.name }}
                                </button>
                            </div>
                        </template>

                        <template v-if="to">
                            <p>
                                <a href="#" class="card-link mr-2" @click.prevent="to = null">
                                    <i class="fas fa-chevron-left"></i>
                                </a>
                                Para: {{ to.name }}
                            </p>
                            <textarea class="form form-control" rows="3" maxlength="140" v-model="mensagem" />
                        </template>
                        
                        <p v-if="!online.length">Nenhum usuário on-line</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit :disabled="!to || !mensagem" @click="enviar()">Enviar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <beautiful-chat
            :participants="participants"
            :titleImageUrl="titleImageUrl"
            :onMessageWasSent="onMessageWasSent"
            :messageList="messageList"
            :newMessagesCount="newMessagesCount"
            :isOpen="isChatOpen"
            :close="closeChat"
            icons2="icons"
            :open="openChat"
            :showEmoji="true"
            :showFile="true"
            :showEdition="true"
            :showDeletion="true"
            :showTypingIndicator="showTypingIndicator"
            :showLauncher="false"
            :showCloseButton="true"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom"
            :messageStyling="messageStyling"
            @onType="handleOnType"
            @edit="editMessage" />

        <!-- Modal -->
        <div class="modal fade" id="modalChat222" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Chat <span class="badge badge-primary" v-if="to">{{ to.name }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!mensagens || !mensagens.length" msg="Nenhuma mensagem trocada." icon="fas fa-comments" />
                        <template v-else>
                            <ul class="list-group">
                                <li class="list-group-item" 
                                    :class="msg.id_usuario == $store.state.user.id_usuario ? 'list-group-item-success' : 'list-group-item-secondary'" 
                                    v-for="(msg, imx) in mensagens" :key="imx">
                                    <div class="small text-muted" :class="msg.id_usuario == $store.state.user.id_usuario ? 'text-right' : ''">
                                        {{ $util.getFormatDate(msg.dt_mensagem) }}
                                        {{ msg.dt_mensagem.substr(11,8) }}
                                    </div>
                                    <div :class="msg.id_usuario == $store.state.user.id_usuario ? 'text-right' : ''">{{ msg.st_mensagem }}</div>
                                </li>
                            </ul>
                        </template>
                        <pre v-if="false">{{ mensagens }}</pre>
                    </div>
                    <div class="modal-footer d-flex flex-column">
                        <div class="w-100">
                            <az-input
                                type="textarea"
                                rows="2"
                                v-model="mensagem">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <az-submit :disabled="!mensagem" @click="enviar()">
                                            <i class="fas fa-paper-plane"></i>
                                        </az-submit>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import EventBus from '../../../service/EventBus';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
//import Chat from 'vue-beautiful-chat';
//import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
//import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
//import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
//import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'

export default {
    data () { 
        return { 
            to: null, 
            online: [],
            mensagem: "", 
            mensagens: [], 
            search: "", 

            /*
            icons2:{
                open:{
                img: OpenIcon,
                name: 'default',
                },
                close:{
                img: CloseIcon,
                name: 'default',
                },
                file:{
                img: FileIcon,
                name: 'default',
                },
                closeSvg:{
                img: CloseIconSvg,
                name: 'default',
                },
            },
            */
           
            participants: [
                {
                id: 'user1',
                name: 'Matteo',
                imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
                },
                {
                id: 'user2',
                name: 'Support',
                imageUrl: 'https://avatars3.githubusercontent.com/u/37018832?s=200&v=4'
                }
            ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
            titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
            messageList: [
                { type: 'text', author: `me`, data: { text: `Say yes!` } },
                { type: 'text', author: `user1`, data: { text: `No.` } }
            ], // the list of the messages to show, can be paginated and adjusted dynamically
            newMessagesCount: 0,
            isChatOpen: false, // to determine whether the chat window should be open or closed
            showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
            colors: {
                header: {
                bg: '#4e8cff',
                text: '#ffffff'
                },
                launcher: {
                bg: '#4e8cff'
                },
                messageList: {
                bg: '#ffffff'
                },
                sentMessage: {
                bg: '#4e8cff',
                text: '#ffffff'
                },
                receivedMessage: {
                bg: '#eaeaea',
                text: '#222222'
                },
                userInput: {
                bg: '#f4f7f9',
                text: '#565867'
                }
            }, // specifies the color scheme for the component
            alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
            messageStyling: true // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
        }
    },
    
    components: { 
        AzSubmit,
        AzInput, 
        AzEmptyState, 
    },

    computed: { 
        lista: function () { 
            if ( !this.online )
                return [];

            let reg = this.$util.getregex(this.search);
            
            return this.online && this.online.length 
                ? _.orderBy(
                    this.online.filter (item => ( !this.search || reg.test(JSON.stringify(item)))),
                    (item) => item.search ? item.search : item.name    
                ) 
                : [];
        }
    },

    methods: { 
        abrir(users) { 
            this.to = null;
            this.mensagem = "";
            this.online = users.filter(item => item.id_usuario != 1);
            $('#chatPanelModal').modal('show');
        },

        enviar () { 
            this.$util.atualizar (this, { 
                service: 'chat',
                func: 'send', 
                dados: { 
                    to: this.to.id_usuario,
                    text: this.mensagem,
                },
                modal: 'chatPanelModal',
                msg: "Mensagem enviada.",
                toast: true,
            });
        },

        receberMensagem(mensagem) { 

            if ( !$('#modalChat').hasClass('show') ) { 

                const texto = "De: " + mensagem.from_name + " >> " + mensagem.text;

                this.$toasted.show(
                    texto, 
                    { 
                        theme: "outline", 
                        position: "top-center", 
                        duration : 10000,
                        action : [
                            {
                                text : 'Fechar',
                                onClick : (e, toastObject) => {
                                    toastObject.goAway(0);
                                }
                            },
                            {
                                text : 'Chat',
                                onClick : () => {
                                    this.$toasted.clear();
                                    this.abrirChatSala(mensagem.from);
                                }

                            }
                        ]
                    }
                );

            } else { 

                this.$util.load(this, { 
                    service: 'chat',
                    func: 'index',
                    parms: { 
                        to: mensagem.from, 
                    },
                    loadTo: res => { 
                        this.mensagens = res.msgs;
                        this.to = { 
                            id_usuario: res.usuario.id_usuario,
                            name: res.usuario.pessoa.st_nome, 
                        };

                        this.$nextTick(() => { 
                            $('#modalChat .modal-body').animate({ scrollTop: 9999 }, 'slow');
                        });
                    }
                });

            }

        },

        abrirChatSala(to) { 
            console.log('=> Abrir sala com', to);

            if ( !$('#modalChat').hasClass('show') ) { 
                $('.modal').modal('hide');
            }

            this.$util.load(this, { 
                service: 'chat',
                func: 'index',
                parms: { 
                    to: to, 
                },
                loadTo: res => { 
                    this.mensagens = res.msgs;
                    this.to = { 
                        id_usuario: res.usuario.id_usuario,
                        name: res.usuario.pessoa.st_nome, 
                    };

                    this.$nextTick(() => { 
                        $('#modalChat .modal-body').animate({ scrollTop: 9999 }, 'slow');
                    });
                }
            });
            
            this.$nextTick(() => { 
                $('#modalChat').modal('show');
            });
        },

        //

        sendMessage (text) {
            if (text.length > 0) {
                this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
                this.onMessageWasSent({ author: 'support', type: 'text', data: { text } })
            }
        },
        onMessageWasSent (message) {
            // called when the user sends a message
            this.messageList = [ ...this.messageList, message ]
        },
        openChat () {
            // called when the user clicks on the fab button to open the chat
            this.isChatOpen = true
            this.newMessagesCount = 0
        },
        closeChat () {
            // called when the user clicks on the botton to close the chat
            this.isChatOpen = false
        },
        handleScrollToTop () {
            // called when the user scrolls message list to top
            // leverage pagination for loading another page of messages
        },
        handleOnType () {
            console.log('Emit typing event')
        },
        editMessage(message){
            const m = this.messageList.find(m=>m.id === message.id);
            m.isEdited = true;
            m.data.text = message.data.text;
        }
    },

    mounted() { 
        EventBus.$on('chat-mensagem', this.abrir);

        EventBus.$on('chat-sala', this.receberMensagem);
    }
}
</script>